import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { ZileLibereService } from '../zile-libere.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize } from 'rxjs';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-add-zile',
  templateUrl: './add-zile.component.html',
  styleUrls: ['./add-zile.component.scss'],
})
export class AddZileComponent {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error;
  errorIcon: string = environment.config.customNotifications.icons.error;
  errorType: string = environment.config.customNotifications.icons.error;
  helper = helper;
  formattedDate!: string;
  token!: string;
  isLoading = false;

  form: FormGroup = new FormGroup({
    off_day_name: new FormControl('', Validators.required),
    date: new FormControl('', Validators.required),
  });

  constructor(
    private dialogRef: MatDialogRef<AddZileComponent>,
    private zileLibereService: ZileLibereService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }
  closeDialog() {
    this.dialogRef?.close({
      success: false,
    });
  }

  onDateChange(event: any) {
    this.formattedDate = formatDate(event.value, 'yyyy-MM-dd', 'en-US');
    console.log(this.formattedDate);
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.zileLibereService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const zileLibere = {
      off_day_name: this.form.get('off_day_name')?.value,
      date: this.formattedDate,
    };
    this.zileLibereService
      .addZileLibere(zileLibere)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res) => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let errorMessage =
            environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(
            this.errorTitle,
            errorMessage,
            this.errorIcon
          );
        },
      });
  }
}
